import { TypeHelper } from "@iconics/core";
import { ODataSelect } from "@iconics/core";

export class Role extends ODataSelect
{
    public Id = "";
    public Name = "";
    public IdentityProviderId = 0;
    public IsOwner = false;

    public init(response: any, nodeId: number): Role
    {
        Object.assign(this, response);
        this.IsOwner = TypeHelper.toBoolean(response.IsOwner) ?? false;
        return this;
    }
}

export class IdentityProvider extends ODataSelect
{
    public Id = 0;
    public Name = "";
}
